import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';

import OneVideo from '@/modules/module-oneVideo';

import '../../styles/pages/home.scss';

export default Backbone.View.extend({
    
    initialize: function(opts){
        
        console.log('init home');
        
        var self = this;
        self.$content = self.$el;
        self.$body = $('body');
        self.$moduleA = self.$content.find('.hp-module-a');
        self.$moduleB2 = self.$content.find('.hp-module-b2')
        self.$moduleC2 = self.$content.find('.hp-module-c2');
        self.$moduleD2 = self.$content.find('.hp-module-d2');

        self.$p_moduleB = self.$content.find('.p-module-b');

        self.$moduleA.length > 0 && _.each(self.$moduleA, (moduleA) => {
            self.moduleA($(moduleA));
        })

        self.$moduleB2.length > 0 && _.each(self.$moduleB2, (moduleB2) => {
            self.moduleB2($(moduleB2));
        })

        self.$moduleC2.length > 0 && _.each(self.$moduleC2, (moduleC2) => {
            self.moduleC2($(moduleC2));
        })

        self.$moduleD2.length > 0 && _.each(self.$moduleD2, (moduleD2) => {
            self.moduleD2($(moduleD2));
        })

        self.$p_moduleB.length > 0 && _.each(self.$p_moduleB, (moduleB) => {
            self.pmoduleB($(moduleB));
        })
    },

    events: {
        
    },

    moduleA: function($module){
        const sectionId = $module.attr(`id`);
        const $videos = $module.find('.video-wrapper');
        const autoplaySpeed = $module.attr('data-slider-speed') || 5000;

        $module.slick({
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed,
            speed: 600,
            slidesToShow: 1,
            arrows: false
        });
        
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: true
        });
    },

    moduleB2: function($module) {
        const self = this;
    },
    

    moduleC2: function($module){
        const self = this;
        const sectionId = $module.attr(`id`);
        const $filters = $module.find('.filters');
        const $filtersLabel = $filters.siblings('label');
        const $blockSlider = $module.find('.slick');

        const filterHandle = e => {
            const selectedTab = $(e.currentTarget).data(`filter`)
            filterBySelectedTab(selectedTab)
        }

        const filterBySelectedTab = (selectedTab) => {
            if (!selectedTab) return false

            // const sliderObj = hp_mc2_sliders[`${sectionId}`]

            let currentFilter = false
            const $activeTab = $filters.find(`.filter.active`)
            if ($activeTab.length) {
                currentFilter = $activeTab.data(`filter`)
                $activeTab.removeClass(`active`)
            }

            const $selectedTab = $filters.find(`.filter[data-filter=${selectedTab}]`)
            $selectedTab.addClass(`active`)
            $filtersLabel.find(`.current-filter`).text($selectedTab.text())

            if (currentFilter && selectedTab != currentFilter) {
                $blockSlider.slick('slickUnfilter')
            }
            $blockSlider.slick('slickFilter', (i, el) => {
                return $(el).find(`[data-filter=${selectedTab}]`).length
            })
            window.ORW.lazyload && window.ORW.lazyload.update()
        }

        const filterActionEventKey = `click #${$filters.attr('id')} .filter:not(.active)`
		self.events[filterActionEventKey] = e => filterHandle(e)
        const mobileFilterDropdownActionEventKey = `click #${sectionId} .filters-wrapper`
        self.events[mobileFilterDropdownActionEventKey] = e => {
            if (self.isMobile) {
                $(e.currentTarget).toggleClass(`dropdown-open`)
            }
        }
        self.delegateEvents();

        /*
            This ugly code block is a trick to handle a uniqe edge case of slick filter
            We need to use our media check function to separately destruct and init the slider
            to avoid a rare filter issue (that slider will disappear).
        */
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
            if ($blockSlider.hasClass(`slick-initialized`)) $blockSlider.slick('unslick')
            $blockSlider.slick({
                dots: false,
                infinite: false,
                speed: 600,
                arrows: false,
                slidesToShow: 4,
                variableWidth: true
            })
            // Apply the first tab as filter on load
            filterBySelectedTab(`tab_1`)
        }, function () {
            // Mobile actions
            if ($blockSlider.hasClass(`slick-initialized`)) $blockSlider.slick('unslick')
            $blockSlider.slick({
                dots: false,
                infinite: false,
                speed: 600,
                arrows: false,
                slidesToShow: 1,
                variableWidth: true
            })
            // Apply the first tab as filter on load
            filterBySelectedTab(`tab_1`)
        })
    },

    moduleD2: function($module){
        const self = this;
        const sectionId = $module.attr(`id`);
        const $container = $module.find(`> .container`);
        const $blocks = $module.find(`.review-block`);
        const $navLists = $module.find(`.navigator li`);

        const navActionEventKey = `click #${sectionId} .navigator button`
        self.events[navActionEventKey] = e => {
            const $curr = $(e.currentTarget)
            const $listParent = $curr.parent()

            if ($listParent.hasClass(`slick-active`)) return

            console.log(`Go to: ${$listParent.data('id')}`);

            if ($listParent && $listParent.data('id')) {
                const targetBlockId = $listParent.data('id')
                const $targetBlock = $module.find(`.review-block[data-id="${targetBlockId}"]`)
                const targetIndex = parseInt($targetBlock.data(`index`)) - 1
                const $targetNavLists = $module.find(`.navigator li[data-id="${targetBlockId}"]`)

                $blocks.removeClass(`is-active`)
                $navLists.removeClass(`slick-active`)

                $container.css(`transform`, `translateX(-${ targetIndex * 10 }%)`)
                $targetBlock.addClass(`is-active`)
                $targetNavLists.addClass(`slick-active`)
            }
            
        }
        self.delegateEvents();
    },

    pmoduleB: function($module){
        const $videos = $module.find('.video-wrapper');
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: true
        });
    },

    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});